import BigNumber from 'bignumber.js'

BigNumber.config({
  EXPONENTIAL_AT: [-1e9, 1e9],
  DECIMAL_PLACES: 20,
  ROUNDING_MODE: BigNumber.ROUND_DOWN,
})
export { BigNumber as BN }
